import React from 'react'
import Page from '../components/Page'
import { Button, Card, CardBody, CardHeader, Col, Label, Row, Table, Modal, ModalBody, ModalFooter, ModalHeader, Nav, NavItem, NavLink, TabContent, TabPane, Form, FormFeedback, FormGroup, FormText, Input } from 'reactstrap'
// import axios from 'axios';
import axios from '../utils/posAxios'
import StorageService from '../services/StorageService'
import { MdCameraAlt, MdFace, MdDone, MdWarning, MdClear, MdCreate, MdKeyboardReturn, MdDelete, MdFileUpload, MdCancel } from 'react-icons/md'
import { BsPlusSquareFill } from 'react-icons/bs'
import { IconContext } from 'react-icons/lib'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { Redirect } from 'react-router'
import classnames from 'classnames'
import { getProductList, getProductCategory, getProductType } from '../utils/dropdownlist'
import update, { extend } from 'immutability-helper'
import Compress from 'compress.js'
import Select from 'react-select'

import '../../node_modules/@syncfusion/ej2-base/styles/material.css'
import '../../node_modules/@syncfusion/ej2-icons/styles/material.css'
import '../../node_modules/@syncfusion/ej2-buttons/styles/material.css'
import '../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css'
import '../../node_modules/@syncfusion/ej2-inputs/styles/material.css'
import '../../node_modules/@syncfusion/ej2-lists/styles/material.css'
import '../../node_modules/@syncfusion/ej2-navigations/styles/material.css'
import '../../node_modules/@syncfusion/ej2-popups/styles/material.css'
import '../../node_modules/@syncfusion/ej2-richtexteditor/styles/material.css'
import { HtmlEditor, Image, Inject, Link, QuickToolbar, RichTextEditorComponent, Toolbar, NodeSelection, PasteCleanup } from '@syncfusion/ej2-react-richtexteditor'

const compress = new Compress()

class PosProductDetailPage extends React.Component {
  _isMounted = true
  constructor(props) {
    super(props)
    this.state = {
      confirmModal: false,
      redirect: false,
      redirectToProduct: false,
      isEdit: this.props.location.state.isEdit,
      isLoading: true,
      productList: [],
      categoryList: [],
      typeList: [],
      id: '',
      product_no: '',
      name: '',
      chn_name: '',
      image: '',
      imagePreviewUrl: '',
      category: '',
      parent: '',
      product_type: '',
      price_data: [{ unit: '', price: '0.00' }],
      update_price: false,
      product_data: '',
      eng_description: '',
      chn_description: '',
      container: '',
      alerts: { stock_warning: { warn: '0', alert: '0', no_order: '0' } },
      tags: '',
      contract: null,
      set: null,
      weight: null,
      default_list: 1,
      list_order: '5',
      video_url: '',
      setItemCheck: true,
      setComboItemCheck: true,
      product_image: [],
      combo: null,
      follow_price: 0,
      supplier_id: '',
      supplierList: [],
      tags1:'',
      tags2:'',
      tags3:'',
      tags4:'',
      tags5:'',
      material:[]
    }

    this.selection = new NodeSelection()
    this.toolbarSettings = {
      items: [
        'Bold',
        'Italic',
        'Underline',
        // 'StrikeThrough',
        //'FontName',
        'FontSize',
        //'FontColor',
        // 'BackgroundColor',
        // 'LowerCase',
        // 'UpperCase',
        // '|',
        //'Formats',
        // 'Alignments',
        // 'OrderedList',
        // 'UnorderedList',
        // 'Outdent',
        // 'Indent',
        // '|',
        'CreateLink',
        // 'Image',
        // '|',
        //'ClearFormat',
        // 'Print',
        // 'SourceCode',
        // 'FullScreen',
        // '|',
        'Undo',
        'Redo',
      ],
    }
    // this.quickToolbarSettings = {
    //   image: [
    //     'Replace',
    //     'Align',
    //     'Caption',
    //     'Remove',
    //     'InsertLink',
    //     'OpenImageLink',
    //     '-',
    //     'EditImageLink',
    //     'RemoveImageLink',
    //     'Display',
    //     'AltText',
    //     'Dimension',
    //   ],
    // };
    // this.imageSettings = {
    //   saveFormat: 'Base64',
    // };

    this.pasteCleanupSettings = {
      allowedStyleProps: ['font-size'],
      deniedAttrs: ['class', 'title', 'id'],
      deniedTags: ['a'],
      keepFormat: false,
      plainText: true,
      prompt: false,
    }
  }

  engDescriptionHandler = value => {
    this.setState({ eng_description: value.value })
  }

  chnDescriptionHandler = value => {
    this.setState({ chn_description: value.value })
  }

  changeHandler = event => {
    const { name, value } = event.target

    this.setState({
      [name]: value,
    })
  }

  contractChangeHandler = event => {
    const { id, name, value } = event.target
    const newData = update(this.state.contract, {
      [name]: { $set: value },
    })
    this.setState({
      contract: newData,
    })
  }

  alertChangeHandler = event => {
    const { id, name, value } = event.target
    const newData = update(this.state.alerts, {
      [id]: { [name]: { $set: value } },
    })
    this.setState({
      alerts: newData,
    })
  }

  priceChangeHandler = event => {
    const { name, value } = event.target
    // if (this.FloatValidation(value)) {
    //   this.setState({
    //     price_data: update(this.state.price_data, {
    //       0: { [name]: { $set: value } },
    //     }),
    //   })
    // }
    this.setState({
      price_data: update(this.state.price_data, {
        0: { [name]: { $set: value } },
      }),
    })
  }

  // FloatValidation = s => () => {
  //   var rgx = /^[0-9]*\.?[0-9]*$/
  //   return s.match(rgx)
  // }

  unitChangeHandler = event => {
    const { name, value } = event.target

    let contract = null
    let set = null
    let combo = null
    let weight = null
    if (this.state.contract === null) {
      contract = {
        no_sessions: '',
        mth_duration: '',
        mth_interval: '',
      }
    } else {
      contract = this.state.contract
    }

    if (this.state.set === null) {
      set = {
        set_type: '',
        item_count: '0',
        product_list: [{ product_id: '', name: '', required: '0' }],
      }
    } else {
      set = this.state.set
    }

    if (this.state.combo === null) {
      combo = [
        {
          name: '',
          set_type: '',
          item_count: '0',
          required: '0',
          product_list: [{ product_id: '', name: '', required: '0' }],
        },
      ]
    } else {
      combo = this.state.combo
    }

    if (this.state.weight === null) {
      weight = [
        {
          weight: '',
          fixed_price: '',
        },
      ]
    } else {
      weight = this.state.weight
    }

    // this.setState({
    //   contract: contract,
    //   set: set,
    // });
    this.setState({
      [name]: value,
      price_data: update(this.state.price_data, {
        0: { [name]: { $set: value } },
      }),
      product_type: value,
      contract: contract,
      set: set,
      combo: combo,
      weight: weight,
    })
  }

  setChangeHandler = e => {
    let { id, name, value } = e.target

    if (id === 'set') {
      this.setState({
        set: update(this.state.set, {
          [name]: { $set: value },
        }),
      })
      if (name === 'item_count') {
        setTimeout(() => {
          this.SetQtyCheck()
        }, 500)
      }
    } else {
      if (name === 'product_id') {
        if (value.length) {
          let product_name = this.state.productList.find(x => x.id == value).name
          this.setState({
            set: update(this.state.set, {
              product_list: {
                [id]: {
                  product_id: { $set: value },
                  name: { $set: product_name },
                },
              },
            }),
          })
        }
      } else {
        this.setState({
          set: update(this.state.set, {
            product_list: {
              [id]: {
                [name]: { $set: value },
              },
            },
          }),
        })
        setTimeout(() => {
          this.SetQtyCheck()
        }, 500)
      }
    }
  }

  combosearchableChangeHandler = (id, index) => e => {
    const { label, value } = e
    console.log(index, id)
    console.log(value)
    let product_name = this.state.productList.find(x => x.id == value).name
    console.log(product_name)
    this.setState({
      combo: update(this.state.combo, {
        [index]: {
          product_list: {
            [id]: {
              product_id: { $set: value },
              name: { $set: product_name },
            },
          },
        },
      }),
    })
  }

  supplierChangeHandler = () => e => {
    //const { label, value } = e
    console.log(e)
    this.setState({
      supplier_id: e == null ? '' : e.value,
    })
  }

  setComboChangeHandler = index => e => {
    let { id, name, value } = e.target

    if (id === 'combo') {
      if (name === 'required') {
        if (this.state.combo[index].item_count == 0 || value > this.state.combo[index].item_count) {
          return
        }
      }
      this.setState({
        combo: update(this.state.combo, {
          [index]: { [name]: { $set: value } },
        }),
      })

      if (name === 'item_count') {
        setTimeout(() => {
          this.SetComboQtyCheck(index)
        }, 500)
      }
    } else {
      if (name === 'product_id') {
        if (value.length) {
          let product_name = this.state.productList.find(x => x.id == value).name
          this.setState({
            combo: update(this.state.combo, {
              [index]: {
                product_list: {
                  [id]: {
                    product_id: { $set: value },
                    name: { $set: product_name },
                  },
                },
              },
            }),
          })
        }
      } else {
        this.setState({
          combo: update(this.state.combo, {
            [index]: {
              product_list: {
                [id]: {
                  [name]: { $set: value },
                },
              },
            },
          }),
        })
        setTimeout(() => {
          this.SetComboQtyCheck(index)
        }, 500)
      }
    }
  }

  weightChangeHandler = index => e => {
    let { id, name, value } = e.target
    this.setState({
      weight: update(this.state.weight, {
        [index]: {
          [name]: { $set: value },
        },
      }),
    })
  }

  materialChangeHandler = index => e => {
    let {id, name, value} = e.target;
    this.setState({
      material: update(this.state.material, {
        [index]:{
          [name]:{ $set:value }
        },
      }),
    })
  }

  SetQtyCheck() {
    let count = 0
    for (let i of this.state.set.product_list) {
      count += parseInt(i.required)
    }
    if (count > parseInt(this.state.set.item_count)) {
      this.notificationSystem.addNotification({
        title: <MdWarning />,
        message: 'Product required number more than Item Count',
        level: 'warning',
        position: 'br',
        autoDismiss: 4,
        dismissible: 'click',
      })
      this.setState({
        setItemCheck: false,
      })
    } else {
      this.setState({
        setItemCheck: true,
      })
    }
  }

  SetComboQtyCheck(index) {
    let count = 0
    for (let i of this.state.combo[index].product_list) {
      count += parseInt(i.required)
    }
    if (count > parseInt(this.state.combo[index].required)) {
      this.notificationSystem.addNotification({
        title: <MdWarning />,
        message: 'Product required number more than Combo Required',
        level: 'warning',
        position: 'br',
        autoDismiss: 4,
        dismissible: 'click',
      })
      this.setState({
        setComboItemCheck: false,
      })
    } else {
      this.setState({
        setComboItemCheck: true,
      })
    }
  }

  AddWeightProduct = () => {
    let data = {
      weight: '',
      fixed_price: '',
    }
    this.setState({
      weight: update(this.state.weight, { $push: [data] }),
    })
  }

  AddMaterial = () => {
    let data = {
      material_code:'',
      qty:'',
    }
    this.setState({
      material: update(this.state.material, {$push:[data]})
    })
  }

  AddSetProduct = () => {
    let data = {
      product_id: '',
      name: '',
      required: '0',
    }
    this.setState({
      set: update(this.state.set, { product_list: { $push: [data] } }),
    })
  }

  RemoveWeightProduct = index => () => {
    if (this.state.weight.length == 1) {
      this.notificationSystem.addNotification({
        title: <MdWarning />,
        message: 'Required At Least 1 Weight',
        level: 'warning',
        position: 'br',
        autoDismiss: 4,
        dismissible: 'click',
      })
    } else {
      this.setState({
        weight: update(this.state.weight, { $splice: [[index, 1]] }),
      })
    }
  }

  RemoveMaterial = index => () => {
    this.setState({
      material:update(this.state.material,{$splice:[[index,1]]})
    })
  }

  RemoveSetProduct = index => () => {
    if (this.state.set.product_list.length == 1) {
      this.notificationSystem.addNotification({
        title: <MdWarning />,
        message: 'Required At Least 1 Product',
        level: 'warning',
        position: 'br',
        autoDismiss: 4,
        dismissible: 'click',
      })
    } else {
      this.setState({
        set: update(this.state.set, {
          product_list: { $splice: [[index, 1]] },
        }),
      })
    }
  }

  AddComboProduct = () => {
    let data = {
      name: '',
      set_type: '',
      item_count: '0',
      required: '0',
      product_list: [{ product_id: '', name: '', required: '0' }],
    }
    this.setState({
      combo: update(this.state.combo, { $push: [data] }),
    })
  }

  RemoveCombo = index => () => {
    if (this.state.combo.length == 1) {
      this.notificationSystem.addNotification({
        title: <MdWarning />,
        message: 'Required At Least 1 Combo',
        level: 'warning',
        position: 'br',
        autoDismiss: 4,
        dismissible: 'click',
      })
    } else {
      this.setState({
        combo: update(this.state.combo, { $splice: [[index, 1]] }),
      })
    }
  }

  AddComboSetProduct = index => {
    let data = {
      product_id: '',
      name: '',
      required: '0',
    }
    this.setState({
      combo: update(this.state.combo, {
        [index]: { product_list: { $push: [data] } },
      }),
    })
  }

  RemoveComboSetProduct = (index, sindex) => () => {
    if (this.state.combo[index].product_list.length == 1) {
      this.notificationSystem.addNotification({
        title: <MdWarning />,
        message: 'Required At Least 1 Product',
        level: 'warning',
        position: 'br',
        autoDismiss: 4,
        dismissible: 'click',
      })
    } else {
      this.setState({
        combo: update(this.state.combo, {
          [index]: { product_list: { $splice: [[sindex, 1]] } },
        }),
      })
    }
  }

  imageChangeHandler = async event => {
    let reader = new FileReader()
    if (Object.keys(event.target.files).length == 0) {
      // Object is empty
    } else {
      let file = event.target.files[0]
      if (!file.name.toLowerCase().match(/\.(jpg|jpeg|png|gif)$/)) {
        this.notificationSystem.addNotification({
          title: <MdWarning />,
          message: 'Please select valid photo.',
          level: 'error',
          position: 'br',
          autoDismiss: 2,
          dismissible: 'click',
        })
      } else {
        let imgResize = await this.resizeImageFn(file)
        reader.onloadend = () => {
          this.setState({
            imagePreviewUrl: imgResize,
          })
        }
        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'Photo has been uploaded.',
          level: 'success',
          position: 'br',
          autoDismiss: 2,
          dismissible: 'click',
        })

        reader.readAsDataURL(file)
      }
    }
  }

  handleAttachmentChange = async event => {
    let reader = new FileReader()
    if (Object.keys(event.target.files).length == 0) {
      // Object is empty
    } else {
      let file = event.target.files[0]
      if (!file.name.toLowerCase().match(/\.(jpg|jpeg|png|gif)$/)) {
        this.notificationSystem.addNotification({
          title: <MdWarning />,
          message: 'Please select valid photo.',
          level: 'error',
          position: 'br',
          autoDismiss: 2,
          dismissible: 'click',
        })
      } else {
        let imgResize = await this.resizeImageFn(file)
        this.AddImage(imgResize)
        // reader.onloadend = () => {
        //   this.setState({
        //     product_image: [
        //       ...this.state.product_image,
        //       { id: file.name, image: imgResize },
        //     ],
        //   });
        // };

        // reader.readAsDataURL(file);
      }
    }
  }

  checkHandler = e => {
    let { name } = e.target
    this.setState({
      [name]: !this.state[name],
    })
  }

  toggleConfirmModal = () => () => {
    return this.setState({
      confirmModal: !this.state.confirmModal,
    })
  }

  closeModal = (title, message, level, reload) => {
    this.notificationSystem.addNotification({
      title: title,
      message: message,
      level: level,
      position: 'br',
      autoDismiss: 2,
      dismissible: 'click',
    })

    this.setState({
      modal: false,
    })

    if (reload) {
      setTimeout(() => this.setState({ redirectToProduct: true }), 1000)
    } else {
      this.getProduct()
    }
  }

  getProduct = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
      product_id: this.props.match.params.id,
    }

    axios
      .post(url + ':3002/v1/product/detail', data)
      .then(response => {
        const result = response.data
        console.log(result);
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          if (result.data.set != null && result.data.set.hasOwnProperty('product_list')) {
            result.data.set.product_list = JSON.parse(result.data.set.product_list)
          }
          this.setState({
            isLoading: false,
            product_id: this.props.match.params.id,
            product_no: result.data.product_no,
            name: result.data.name,
            chn_name: result.data.chn_name,
            image: result.data.image,
            category: result.data.category,
            parent_id: result.data.parent_id,
            product_type: result.data.product_type,
            price_data: JSON.parse(result.data.price_data),
            product_data: result.data.product_data,
            eng_description: result.data.eng_description,
            chn_description: result.data.chn_description,
            container: result.data.container,
            alerts: result.data.alerts ? JSON.parse(result.data.alerts) : { stock_warning: { warn: '0', alert: '0', no_order: '0' } },
            tags: result.data.tags,
            contract: result.data.contract,
            set: result.data.set,
            combo: result.data.combo,
            weight: result.data.weight,
            default_list: result.data.default_list,
            list_order: result.data.list_order,
            video_url: result.data.video_url,
            product_image: result.data.product_image,
            follow_price: result.data.follow_price,
            supplier_id: result.data.supplier_id == null ? '' : result.data.supplier_id,
            material:result.data.material
            //supplier_id: result.data.supplier_id,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  getSupplier = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    }

    axios
      .post(url + ':3002/v1/product/supplier', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          this.setState({
            supplierList: result.data,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  AddImage(b64image) {
    const url = process.env.REACT_APP_UNITY_API2_URL
    const user = StorageService.getSession('user_info')
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      product_id: this.state.product_id,
      b64image: b64image,
      created_by: user.email,
    }
    axios
      .post(url + ':3002/v1/product/image/add', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.closeModal(<MdClear />, result.message, 'error', false)
          return
        }

        this.closeModal(<MdDone />, 'New Image added successfully.', 'success', false)
        this.getProduct()
      })
      .catch(error => {
        alert(error)
      })
  }

  RemoveImage(id) {
    const url = process.env.REACT_APP_UNITY_API2_URL
    const user = StorageService.getSession('user_info')
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      image_id: id,
      remove_by: user.email,
    }
    axios
      .post(url + ':3002/v1/product/image/remove', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.closeModal(<MdClear />, result.message, 'error', false)
          return
        }

        this.closeModal(<MdDone />, 'Image Removed successfully.', 'success', false)
        this.getProduct()
      })
      .catch(error => {
        alert(error)
      })
  }

  handleSubmit = event => {
    event.preventDefault()
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    let image = ''
    if (this.state.imagePreviewUrl) {
      // image = this.state.imagePreviewUrl.split(',')[1];
      image = this.state.imagePreviewUrl
    }
    let checkBeforeSubmit = true

    if (this.state.product_type === 'set') {
      checkBeforeSubmit = this.state.setItemCheck
    }

    if (this.state.product_type === 'combo') {
      checkBeforeSubmit = this.state.setComboItemCheck
    }
    if (checkBeforeSubmit == true) {
      if (!this.state.isEdit) {
        this.createProduct(user, comp, url, image)
      } else {
        this.editProduct(user, comp, url, image)
      }
    } else {
      this.notificationSystem.addNotification({
        title: <MdWarning />,
        message: 'Product required number more than Item Count test',
        level: 'warning',
        position: 'br',
        autoDismiss: 4,
        dismissible: 'click',
      })
    }
  }

  createProduct(user, comp, url, image) {
    let price_data = [...this.state.price_data]

    price_data[0].price = parseFloat(price_data[0].price).toFixed(2)

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
      product_no: this.state.product_no,
      name: this.state.name,
      chn_name: this.state.chn_name,
      category: this.state.category,
      parent_id: this.state.parent_id,
      product_date: this.state.default_value,
      product_type: this.state.product_type,
      eng_description: this.state.eng_description,
      chn_description: this.state.chn_description,
      container: this.state.container,
      price_data: JSON.stringify(price_data),
      alerts: JSON.stringify(this.state.alerts),
      tags: this.state.tags,
      b64image: image,
      created_by: user.email,
      contract: this.state.contract,
      set: this.state.set,
      combo: this.state.combo,
      weight: this.weightConvertFloat(),
      default_list: this.state.default_list ? '1' : '0',
      list_order: this.state.list_order,
      video_url: this.state.video_url,
      follow_price: this.state.follow_price ? 1 : 0,
      supplier_id: this.state.supplier_id,
    }

    axios
      .post(url + ':3002/v6/product/add', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.closeModal(<MdClear />, result.message, 'error', false)
          return
        }

        this.closeModal(<MdDone />, 'New product added successfully.', 'success', true)
      })
      .catch(error => {
        alert(error)
      })
  }

  editProduct(user, comp, url, image) {
    let price_data = [...this.state.price_data]

    price_data[0].price = parseFloat(price_data[0].price).toFixed(2)

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
      product_id: this.state.product_id,
      product_no: this.state.product_no,
      name: this.state.name,
      chn_name: this.state.chn_name,
      category: this.state.category,
      parent_id: this.state.parent_id,
      product_date: this.state.default_value,
      product_type: this.state.product_type,
      eng_description: this.state.eng_description == null ? '' : this.state.eng_description,
      chn_description: this.state.chn_description == null ? '' : this.state.chn_description,
      container: this.state.container,
      price_data: JSON.stringify(price_data),
      update_price: this.state.update_price ? '1' : '0',
      alerts: JSON.stringify(this.state.alerts),
      tags: this.state.tags,
      b64image: image,
      update_by: user.email,
      contract: this.state.contract,
      set: this.state.set,
      combo: this.state.combo,
      weight: this.state.product_type == 'weight' ? this.weightConvertFloat() : null,
      default_list: this.state.default_list ? '1' : '0',
      list_order: this.state.list_order,
      video_url: this.state.video_url,
      follow_price: this.state.follow_price ? 1 : 0,
      supplier_id: this.state.supplier_id,
      material:this.state.material
    }

    axios
      .post(url + ':3002/v7/product/update', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.closeModal(<MdClear />, result.message, 'error', false)
          return
        }

        this.closeModal(<MdDone />, 'Product updated successfully.', 'success', false)
      })
      .catch(error => {
        alert(error)
      })
  }

  weightConvertFloat() {
    let weight = [...this.state.weight]
    for (let i of weight) {
      if (i.fixed_price) {
        i.fixed_price = parseFloat(i.fixed_price).toFixed(2)
      }
    }

    return weight
  }

  resizeImageFn = async file => {
    const resizedImage = await compress.compress([file], {
      size: 2, // the max size in MB, defaults to 2MB
      quality: 1, // the quality of the image, max is 1,
      maxWidth: 800, // the max width of the output image, defaults to 1920px
      maxHeight: 800, // the max height of the output image, defaults to 1920px
      resize: true, // defaults to true, set false if you do not want to resize the image width and height
    })
    const img = resizedImage[0]
    const base64str = img.data
    return base64str
    // const imgExt = img.ext;
    // const resizedFiile = Compress.convertBase64ToFile(base64str, imgExt);
    // return resizedFiile;
  }

  delete() {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      product_id: this.state.product_id,
      delete_by: user.email,
    }

    axios
      .post(url + ':3002/v1/product/delete', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.closeModal(<MdClear />, result.message, 'error', false)
          return
        }

        this.closeModal(<MdDone />, 'Product deleted successfully.', 'success', true)
      })
      .catch(error => {
        alert(error)
      })
  }

  componentDidMount() {
    if (this._isMounted) {
      getProductList.call(this)
      getProductCategory.call(this)
      getProductType.call(this)
      this.getSupplier()
    }

    if (this.props.location.state.isEdit) {
      this.getProduct()
    }
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  dropdown(max) {
    var option = []
    for (var i = 0; i <= max; i++) {
      option.push(
        <option key={i} value={i}>
          {i}
        </option>,
      )
    }
    return option
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/" />
    }
    if (this.state.redirectToProduct) {
      return <Redirect to="/posproduct" />
    }

    let options = [
      ...this.state.productList
        .reduce((r, o) => {
          let key = o.id
          let item = { value: o.id, label: o.id + '-' + o.name }
          return r.set(key, item)
        }, new Map())
        .values(),
    ]

    //let supplier_options = [{ value: '', label: '' }]

    let supplier_options = [
      ...this.state.supplierList
        .reduce((r, o) => {
          let key = o.id
          let item = { value: o.id, label: o.name }
          return r.set(key, item)
        }, new Map())
        .values(),
    ]

    return (
      <Page
        className="PosProductDetailPage"
        title="Product Detail"
        breadcrumbs={[
          { name: 'Product', active: false, path: '/posproduct' },
          { name: 'Detail', active: true, path: '/posproduct/:id' },
        ]}>
        <NotificationSystem dismissible={false} ref={notificationSystem => (this.notificationSystem = notificationSystem)} style={NOTIFICATION_SYSTEM_STYLE} />
        <Form className="productForm" onSubmit={this.handleSubmit}>
          <Row>
            <Col xl={6} lg={12} md={12}>
              <Card>
                <CardBody>
                  {this.state.image && (
                    <FormGroup className="text-center">
                      <img style={{ maxWidth: 200 }} src={this.state.image} />
                    </FormGroup>
                  )}

                  <FormGroup>
                    <Label for="product_no">Product No.*</Label>
                    <Input type="text" name="product_no" value={this.state.product_no} onChange={this.changeHandler} required />
                  </FormGroup>
                  <FormGroup>
                    <Label>List Order</Label>
                    <Input type="select" name="list_order" value={this.state.list_order} onChange={this.changeHandler}>
                      {this.dropdown(10)}
                    </Input>
                  </FormGroup>
                  <Row form>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="name">Name*</Label>
                        <Input type="text" name="name" value={this.state.name} onChange={this.changeHandler} required />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="chn_name">Chinese Name</Label>
                        <Input type="text" name="chn_name" value={this.state.chn_name} onChange={this.changeHandler} />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row form>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="category">Category*</Label>
                        <Input type="select" name="category" value={this.state.category} onChange={this.changeHandler} required>
                          <option></option>
                          {this.state.categoryList.map(item => {
                            return (
                              <option key={item.id} value={item.name}>
                                {item.name}
                              </option>
                            )
                          })}
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="unit">Product Type*</Label>
                        <Input type="select" name="unit" value={this.state.product_type} onChange={this.unitChangeHandler} required>
                          <option></option>
                          {this.state.typeList.map(item => {
                            return (
                              <option key={item.type} value={item.type}>
                                {item.type}
                              </option>
                            )
                          })}
                        </Input>
                        <span>We will be removing Set by end of 2021. Please select Combo instead</span>
                      </FormGroup>
                    </Col>
                  </Row>
                  <FormGroup>
                    <Label for="price">Price*</Label>
                    <Input type="number" step=".01" name="price" value={this.state.price_data[0].price} onChange={this.priceChangeHandler} required={!this.state.follow_price} disabled={this.state.follow_price} />
                  </FormGroup>
                  <FormGroup check>
                    <Label>
                      <Input type="checkbox" name="update_price" checked={this.state.update_price} onChange={this.checkHandler} />
                      Update Price to All Store
                    </Label>
                  </FormGroup>
                  <FormGroup check>
                    <Label check>
                      <Input type="checkbox" name="default_list" checked={this.state.default_list} onChange={this.checkHandler} />
                      Show In Menu
                    </Label>
                  </FormGroup>
                  <FormGroup>
                    <Label for="image">Image</Label>
                    <Input type="file" name="image" onChange={this.imageChangeHandler} />
                  </FormGroup>

                  <Row form>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="parent_id">Parent ID</Label>
                        <Input type="select" name="parent_id" value={this.state.parent_id ? this.state.parent_id : ''} onChange={this.changeHandler}>
                          <option></option>
                          {this.state.productList.map(item => {
                            return (
                              <option key={item.id} value={item.id}>
                                {item.product_no} - {item.name}
                              </option>
                            )
                          })}
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="parent_id">Supplier ID</Label>
                        {/* <Input type="select" name="parent_id" value={this.state.parent_id ? this.state.parent_id : ''} onChange={this.changeHandler}>
                          <option></option>
                          {this.state.productList.map(item => {
                            return (
                              <option key={item.id} value={item.id}>
                                {item.product_no} - {item.name}
                              </option>
                            )
                          })}
                        </Input> */}
                        <Select options={supplier_options} value={this.state.supplier_id != null && this.state.supplier_id.length > 0 && supplier_options.filter(x => x.value == this.state.supplier_id)} name="supplier_id" onChange={this.supplierChangeHandler()} menuPosition={'fixed'} isClearable />
                      </FormGroup>
                    </Col>
                  </Row>

                  <FormGroup check>
                    <Label check>
                      <Input type="checkbox" name="follow_price" checked={this.state.follow_price} onChange={this.checkHandler} />
                      Follow Price
                    </Label>
                  </FormGroup>
                  {this.state.isEdit && (
                    <FormGroup>
                      <div>
                        <Input type="file" name="file" id="file" className="ps-input-file" onChange={this.handleAttachmentChange} />
                        <Label for="file">
                          <MdFileUpload /> Additional Product Image
                        </Label>
                      </div>
                      <div className={`ps-photo ${this.state.product_image.length < 1 ? ' empty' : ''}`}>
                        {this.state.product_image.length < 1 && <p>No image</p>}
                        {this.state.product_image.length > 0 &&
                          this.state.product_image.map((item, index) => {
                            return (
                              item.image !== '' && (
                                <div className="image" key={index}>
                                  <MdCancel className="remove" onClick={() => this.RemoveImage(item.id)} />
                                  <img src={item.image} alt="logo" />
                                </div>
                              )
                            )
                          })}
                      </div>
                    </FormGroup>
                  )}
                  <FormGroup>
                    <Label>
                      YouTube ID (
                      <span
                        style={{
                          textDecorationLine: 'line-through',
                          textDecorationStyle: 'solid',
                        }}>
                        https://www.youtube.com/watch?v=
                      </span>
                      2lAe1cqCOXo)
                    </Label>
                    <Input type="text" name="video_url" value={this.state.video_url} onChange={this.changeHandler} />
                  </FormGroup>
                  <FormGroup>
                      <Row form>
                        <Col md={12}>
                          <FormGroup>
                            <Label>
                              Material Code{' '}
                              <Button color="link" onClick={this.AddMaterial}>
                                <IconContext.Provider value={{ color: '#2a2c6b' }}>
                                  <BsPlusSquareFill size={25} />
                                </IconContext.Provider>
                              </Button>
                            </Label>
                            <Table responsive hover className="ps-table tb-col-3">
                              <thead>
                                <tr>
                                  <th>Material Code</th>
                                  <th>Quantity</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {this.state.material &&
                                  this.state.material.length > 0 &&
                                  this.state.material.map((item, index) => {
                                    return (
                                      <tr key={index}>
                                        <td>
                                          <Input type="text" name="material_code" value={item.material_code} onChange={this.materialChangeHandler(index)} required />
                                        </td>
                                        <td>
                                          <Input type="number" id={index} name="qty" value={item.qty} onChange={this.materialChangeHandler(index)} />
                                        </td>
                                        <td>
                                          <div className="ps-action-button">
                                            <Button
                                              style={{
                                                backgroundColor: 'transparent',
                                                border: 'none',
                                              }}
                                              className="theme-button theme-button-primary-light"
                                              onClick={this.RemoveMaterial(index)}>
                                              <IconContext.Provider value={{ color: '#2a2c6b' }}>
                                                <MdDelete size={25} />
                                              </IconContext.Provider>
                                            </Button>
                                          </div>
                                        </td>
                                      </tr>
                                    )
                                  })}
                              </tbody>
                            </Table>
                          </FormGroup>
                        </Col>
                      </Row>
                    </FormGroup>
                </CardBody>
              </Card>
            </Col>
            <Col xl={6} lg={12} md={12}>
              <Card>
                <CardBody>
                  {/* <FormGroup>
                    <Label for="product_data">Product Data</Label>
                    <Input
                      type="text"
                      name="product_data"
                      value={this.state.product_data}
                      onChange={this.changeHandler}
                    />
                  </FormGroup> */}
                  <FormGroup>
                    <Label for="eng_description">Description (EN)</Label>
                    {/* <Input
                      type="textarea"
                      name="eng_description"
                      rows="3"
                      value={this.state.eng_description}
                      onChange={this.changeHandler}
                    /> */}
                    <RichTextEditorComponent
                      height={250}
                      toolbarSettings={this.toolbarSettings}
                      pasteCleanupSettings={this.pasteCleanupSettings}
                      // insertImageSettings={this.imageSettings}
                      // quickToolbarSettings={this.quickToolbarSettings}
                      value={this.state.eng_description}
                      change={this.engDescriptionHandler}>
                      <Inject
                        services={[
                          Toolbar,
                          //Image,
                          Link,
                          HtmlEditor,
                          QuickToolbar,
                          PasteCleanup,
                        ]}
                      />
                    </RichTextEditorComponent>
                  </FormGroup>
                  <FormGroup>
                    <Label for="chn_description">Description (CN)</Label>
                    {/* <Input
                      type="textarea"
                      name="chn_description"
                      rows="3"
                      value={
                        this.state.chn_description
                          ? this.state.chn_description
                          : ''
                      }
                      onChange={this.changeHandler}
                    /> */}
                    <RichTextEditorComponent
                      height={250}
                      toolbarSettings={this.toolbarSettings}
                      pasteCleanupSettings={this.pasteCleanupSettings}
                      //FileManagerComponent={this.FileManagerComponent}
                      // insertImageSettings={this.imageSettings}
                      // quickToolbarSettings={this.quickToolbarSettings}
                      value={this.state.chn_description}
                      change={this.chnDescriptionHandler}>
                      {/* <FileManagerComponent allowDragAndDrop={false}> */}
                      <Inject services={[Toolbar, Image, Link, HtmlEditor, QuickToolbar, PasteCleanup]} />
                      {/* </FileManagerComponent> */}
                    </RichTextEditorComponent>
                  </FormGroup>
                  <Row form>
                    <Col md={4}>
                      <FormGroup>
                        <Label for="warn">Stock Warning*</Label>
                        <Input type="text" id="stock_warning" name="warn" value={this.state.alerts.stock_warning.warn} onChange={this.alertChangeHandler} required />
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup>
                        <Label for="alert">Stock Alert*</Label>
                        <Input type="text" id="stock_warning" name="alert" value={this.state.alerts.stock_warning.alert} onChange={this.alertChangeHandler} required />
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup>
                        <Label for="no_order">No Order*</Label>
                        <Input type="text" id="stock_warning" name="no_order" value={this.state.alerts.stock_warning.no_order} onChange={this.alertChangeHandler} required />
                      </FormGroup>
                    </Col>
                    <span>Stock Warning, Alert and No Order will only be available on POS</span>
                  </Row>
                  <br />
                  <FormGroup>
                    <Label for="tags">Tags</Label>
                    <Input type="textarea" rows={5} name="tags" value={this.state.tags} onChange={this.changeHandler} />
                  </FormGroup>
                  {this.state.product_type === 'contract' && this.state.contract !== null && (
                    <FormGroup>
                      <Label for="contract">Contract</Label>
                      <Row form>
                        <Col md={4}>
                          <FormGroup>
                            <Label>No of Session*</Label>
                            <Input type="text" id="contract" name="no_sessions" value={this.state.contract.no_sessions} onChange={this.contractChangeHandler} required />
                          </FormGroup>
                        </Col>
                        <Col md={4}>
                          <FormGroup>
                            <Label>Duration*</Label>
                            <Input type="text" id="contract" name="mth_duration" value={this.state.contract.mth_duration} onChange={this.contractChangeHandler} required />
                          </FormGroup>
                        </Col>
                        <Col md={4}>
                          <FormGroup>
                            <Label for="no_order">Interval*</Label>
                            <Input type="text" id="contract" name="mth_interval" value={this.state.contract.mth_interval} onChange={this.contractChangeHandler} required />
                          </FormGroup>
                        </Col>
                      </Row>
                    </FormGroup>
                  )}

                  {this.state.product_type === 'set' && this.state.set !== null && (
                    <FormGroup>
                      <Label>Set</Label>
                      <Row form>
                        <Col md={6}>
                          <FormGroup>
                            <Label>Type*</Label>
                            <Input type="select" id="set" name="set_type" value={this.state.set.set_type} onChange={this.setChangeHandler} required>
                              <option></option>
                              <option value="ANY">ANY</option>
                              <option value="TOP UP">TOP UP</option>
                            </Input>
                          </FormGroup>
                        </Col>
                        <Col md={6}>
                          <FormGroup>
                            <Label>Item Count*</Label>
                            <Input type="number" id="set" name="item_count" value={this.state.set.item_count} onChange={this.setChangeHandler} required />
                          </FormGroup>
                        </Col>
                        <Col md={12}>
                          <FormGroup>
                            <Label>
                              Product List*{' '}
                              <Button color="link" onClick={this.AddSetProduct}>
                                <IconContext.Provider value={{ color: '#2a2c6b' }}>
                                  <BsPlusSquareFill size={25} />
                                </IconContext.Provider>
                              </Button>
                            </Label>
                            <Table responsive hover className="ps-table tb-col-5">
                              <thead>
                                <tr>
                                  <th>Product ID</th>
                                  <th>Name</th>
                                  <th>Required</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {this.state.set &&
                                  this.state.set.hasOwnProperty('product_list') &&
                                  this.state.set.product_list.length > 0 &&
                                  this.state.set.product_list.map((item, index) => {
                                    return (
                                      <tr key={index}>
                                        <td>
                                          <Input type="select" id={index} name="product_id" value={item.product_id} onChange={this.setChangeHandler} required>
                                            <option></option>
                                            {this.state.productList.length > 0 &&
                                              this.state.productList.map(item => {
                                                return (
                                                  <option key={item.id} value={item.id}>
                                                    {item.id} {'-'} {item.name}
                                                  </option>
                                                )
                                              })}
                                          </Input>
                                        </td>
                                        <td>
                                          <Input type="text" value={item.name} readOnly />
                                        </td>
                                        <td>
                                          <Input type="number" id={index} name="required" value={item.required} onChange={this.setChangeHandler} required />
                                        </td>
                                        <td>
                                          <div className="ps-action-button">
                                            <Button
                                              style={{
                                                backgroundColor: 'transparent',
                                                border: 'none',
                                              }}
                                              className="theme-button theme-button-primary-light"
                                              onClick={this.RemoveSetProduct(index)}>
                                              <IconContext.Provider value={{ color: '#2a2c6b' }}>
                                                <MdDelete size={25} />
                                              </IconContext.Provider>
                                            </Button>
                                          </div>
                                        </td>
                                      </tr>
                                    )
                                  })}
                              </tbody>
                            </Table>
                          </FormGroup>
                        </Col>
                      </Row>
                    </FormGroup>
                  )}

                  {this.state.product_type == 'combo' && this.state.combo !== null && (
                    <FormGroup>
                      <Label>
                        Combo{' '}
                        <Button color="link" onClick={this.AddComboProduct}>
                          <IconContext.Provider value={{ color: '#2a2c6b' }}>
                            <BsPlusSquareFill size={25} />
                          </IconContext.Provider>
                        </Button>
                      </Label>
                      {this.state.combo.map((item, index) => {
                        return (
                          <Row
                            form
                            key={index}
                            style={{
                              padding: '10px',
                              border: '1px solid #ced4da',
                            }}>
                            <Col md={3}>
                              <FormGroup>
                                <Label>Name*</Label>
                                <Input type="text" id="combo" name="name" value={item.name} onChange={this.setComboChangeHandler(index)} required />
                              </FormGroup>
                            </Col>
                            <Col md={3}>
                              <FormGroup>
                                <Label>Type*</Label>
                                <Input type="select" id="combo" name="set_type" value={item.set_type} onChange={this.setComboChangeHandler(index)} required>
                                  <option></option>
                                  <option value="ANY">ANY</option>
                                  <option value="TOP UP">TOP UP</option>
                                </Input>
                              </FormGroup>
                            </Col>
                            <Col md={3}>
                              <FormGroup>
                                <Label>Item Count*</Label>
                                <Input type="number" id="combo" name="item_count" value={item.item_count} onChange={this.setComboChangeHandler(index)} required />
                              </FormGroup>
                            </Col>
                            <Col md={3}>
                              <FormGroup style={{ position: 'relative' }}>
                                <Label>
                                  Required*{' '}
                                  <Button
                                    color="link"
                                    onClick={this.RemoveCombo(index)}
                                    style={{
                                      position: 'absolute',
                                      right: 0,
                                      padding: 0,
                                      margin: '-1vh',
                                    }}>
                                    <IconContext.Provider value={{ color: '#2a2c6b' }}>
                                      <MdDelete size={25} />
                                    </IconContext.Provider>
                                  </Button>
                                </Label>
                                <Input type="number" id="combo" name="required" value={item.required} onChange={this.setComboChangeHandler(index)} required />
                              </FormGroup>
                            </Col>
                            <Col md={12}>
                              <FormGroup>
                                <Label>
                                  Product List*{' '}
                                  <Button color="link" onClick={() => this.AddComboSetProduct(index)}>
                                    <IconContext.Provider value={{ color: '#2a2c6b' }}>
                                      <BsPlusSquareFill size={25} />
                                    </IconContext.Provider>
                                  </Button>
                                </Label>
                                <Table responsive hover className="ps-table tb-col-5">
                                  <thead>
                                    <tr>
                                      <th>Product ID</th>
                                      <th>Name</th>
                                      <th>Required</th>
                                      <th>Action</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {item.product_list &&
                                      item.product_list.length > 0 &&
                                      item.product_list.map((sitem, sindex) => {
                                        return (
                                          <tr key={sindex}>
                                            <td>
                                              {/* <Input type="select" id={sindex} name="product_id" value={sitem.product_id} onChange={this.setComboChangeHandler(index)} required>
                                                <option></option>
                                                {this.state.productList.length > 0 &&
                                                  this.state.productList.map(item => {
                                                    return (
                                                      <option key={item.id} value={item.id}>
                                                        {item.id} {'-'} {item.name}
                                                      </option>
                                                    )
                                                  })}
                                              </Input> */}
                                              <Select options={options} value={options.filter(i => i.value == sitem.product_id)} name="product_id" onChange={this.combosearchableChangeHandler(sindex, index)} menuPosition={'fixed'} required />
                                            </td>
                                            <td>
                                              <Input type="text" value={sitem.name} readOnly />
                                            </td>
                                            <td>
                                              <Input type="number" id={sindex} name="required" value={sitem.required} onChange={this.setComboChangeHandler(index)} required />
                                            </td>
                                            <td>
                                              <div className="ps-action-button">
                                                <Button
                                                  style={{
                                                    backgroundColor: 'transparent',
                                                    border: 'none',
                                                  }}
                                                  className="theme-button theme-button-primary-light"
                                                  onClick={this.RemoveComboSetProduct(index, sindex)}>
                                                  <IconContext.Provider
                                                    value={{
                                                      color: '#2a2c6b',
                                                    }}>
                                                    <MdDelete size={25} />
                                                  </IconContext.Provider>
                                                </Button>
                                              </div>
                                            </td>
                                          </tr>
                                        )
                                      })}
                                  </tbody>
                                </Table>
                              </FormGroup>
                            </Col>
                          </Row>
                        )
                      })}
                    </FormGroup>
                  )}

                  {this.state.product_type == 'weight' && this.state.weight !== null && (
                    <FormGroup>
                      <Row form>
                        <Col md={12}>
                          <FormGroup>
                            <Label>
                              Weight List*{' '}
                              <Button color="link" onClick={this.AddWeightProduct}>
                                <IconContext.Provider value={{ color: '#2a2c6b' }}>
                                  <BsPlusSquareFill size={25} />
                                </IconContext.Provider>
                              </Button>
                            </Label>
                            <Table responsive hover className="ps-table tb-col-3">
                              <thead>
                                <tr>
                                  <th>Weight</th>
                                  <th>Fixed Price</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {this.state.weight &&
                                  this.state.weight.length > 0 &&
                                  this.state.weight.map((item, index) => {
                                    return (
                                      <tr key={index}>
                                        <td>
                                          <Input type="number" name="weight" value={item.weight} onChange={this.weightChangeHandler(index)} required />
                                        </td>
                                        <td>
                                          <Input type="number" id={index} name="fixed_price" value={item.fixed_price} onChange={this.weightChangeHandler(index)} />
                                        </td>
                                        <td>
                                          <div className="ps-action-button">
                                            <Button
                                              style={{
                                                backgroundColor: 'transparent',
                                                border: 'none',
                                              }}
                                              className="theme-button theme-button-primary-light"
                                              onClick={this.RemoveWeightProduct(index)}>
                                              <IconContext.Provider value={{ color: '#2a2c6b' }}>
                                                <MdDelete size={25} />
                                              </IconContext.Provider>
                                            </Button>
                                          </div>
                                        </td>
                                      </tr>
                                    )
                                  })}
                              </tbody>
                            </Table>
                          </FormGroup>
                        </Col>
                      </Row>
                    </FormGroup>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col>
              <div className="ps-btn-group text-left">
                <Button
                  className="theme-button theme-button-dark"
                  onClick={() => {
                    window.history.back()
                  }}>
                  <MdKeyboardReturn />
                  Back
                </Button>
              </div>
            </Col>
            <Col>
              <div className="ps-btn-group text-right">
                <Button className="theme-button theme-button-primary" type="submit">
                  {this.state.isEdit ? 'Save' : 'Create'}
                </Button>
                {this.state.isEdit && (
                  <Button className="theme-button theme-button-primary-light" onClick={this.toggleConfirmModal()}>
                    Delete
                  </Button>
                )}
              </div>
            </Col>
          </Row>
        </Form>

        <Modal isOpen={this.state.confirmModal} toggle={this.toggleConfirmModal()} className={this.props.className} centered style={{ fontSize: '0.85rem' }}>
          <ModalHeader toggle={this.toggleConfirmModal()}>Delete Product</ModalHeader>
          <ModalBody>
            <Row>
              <Col md={12}>
                <p>Are you sure you want to delete {this.state.name} ?</p>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button className="theme-button theme-button-secondary" onClick={this.toggleConfirmModal()}>
              No
            </Button>
            <Button className="theme-button theme-button-primary" onClick={() => this.delete()}>
              Yes
            </Button>
          </ModalFooter>
        </Modal>
      </Page>
    )
  }
}
export default PosProductDetailPage
